module.exports = __webpack_public_path__ + "img/22_64.c335386f.png";